import React from 'react';

export default ({ backgroundColor = '#000000', foregroundColor = '#ffffff' }) => {
  return (
    <svg width="68" height="68" viewBox="0 0 68 68">
      <circle cx="34" cy="34" r="34" style={{ fill: backgroundColor }} />
      <rect x="28.5" y="10.58824" width="11" height="32" style={{ fill: foregroundColor }} />
      <rect x="28.5" y="47.55882" width="11" height="11" style={{ fill: foregroundColor }} />
    </svg>
  );
};
